<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 78 70">
        <path
            fill="currentColor"
            fill-opacity=".5"
            d="M7.737 27.232 5.62 31.434l-4.733.676c-.85.12-1.19 1.145-.574 1.732l3.425 3.269-.81 4.617c-.146.835.752 1.46 1.503 1.07l4.235-2.18 4.234 2.18c.752.387 1.65-.235 1.504-1.07l-.81-4.617 3.424-3.269c.616-.587.275-1.612-.573-1.732l-4.734-.676-2.115-4.202c-.38-.749-1.478-.758-1.86 0ZM68.403 27.232l-2.115 4.202-4.734.676c-.849.12-1.189 1.145-.573 1.732l3.424 3.269-.81 4.617c-.145.835.752 1.46 1.504 1.07l4.234-2.18 4.235 2.18c.751.387 1.649-.235 1.503-1.07l-.81-4.617 3.425-3.269c.615-.587.275-1.612-.574-1.732l-4.733-.676-2.116-4.202c-.38-.749-1.477-.758-1.86 0Z"
        />
        <path
            fill="currentColor"
            stroke="currentColor"
            d="m30.193 15.425-.259.037-14.2 2.028c-2.148.305-2.98 2.879-1.446 4.341l10.274 9.807.193.184-.046.264-2.43 13.851c-.361 2.07 1.876 3.672 3.787 2.679h.002l12.703-6.541.229-.118.229.118 12.703 6.54c1.915.986 4.15-.61 3.789-2.677L30.193 15.425Zm0 0 .117-.233 6.347-12.604c.96-1.904 3.731-1.886 4.686 0l6.347 12.604.117.233.259.037 14.2 2.028c2.148.305 2.98 2.879 1.446 4.341l-10.274 9.807-.193.184.046.264 2.43 13.851-25.528-30.511Z"
        />
        <rect
            width="4.333"
            height="13"
            fill="currentColor"
            fill-opacity=".5"
            rx="2.167"
            transform="matrix(-1 0 0 1 32.5 52.667)"
        />
        <rect
            width="4.333"
            height="13"
            fill="currentColor"
            fill-opacity=".5"
            rx="2.167"
            transform="matrix(-1 0 0 1 49.834 52.667)"
        />
        <rect
            width="4.333"
            height="21.667"
            fill="currentColor"
            fill-opacity=".5"
            rx="2.167"
            transform="matrix(-1 0 0 1 41.166 48.334)"
        />
    </svg>
</template>

<script>
export default {
    name: "RisingStarIcon",
};
</script>
